import React from 'react'
import { Typography, Button } from '@material-ui/core'
import FullscreenIcon from '@material-ui/icons/Fullscreen'
import Logo from '../Logo/Logo'
import { useStyles } from './FullscreenPromptStyles'

function FullscreenPrompt({ onEnterFullscreen, height }) {
  const classes = useStyles()

  return (
    <div className={classes.root} style={{ height: height || '100vh' }}>
      <div className={classes.header}>
        <Logo />
      </div>
      <div className={classes.body}>
        <div className={classes.card}>
          <div className={classes.iconCircle}>
            <FullscreenIcon className={classes.icon} />
          </div>
          <Typography className={classes.title}>Fullscreen required</Typography>
          <Typography className={classes.subtitle}>
            To maintain exam integrity, this test must be taken in fullscreen
            mode. Exiting fullscreen will be recorded as a violation.
          </Typography>
          <div className={classes.divider} />
          <Button
            variant="outlined"
            className={classes.button}
            startIcon={<FullscreenIcon />}
            onClick={onEnterFullscreen}
          >
            Enter Fullscreen
          </Button>
          <Typography className={classes.hint}>
            Pressing <span className={classes.key}>Esc</span> will exit
            fullscreen and be flagged.
          </Typography>
        </div>
      </div>
    </div>
  )
}

export default FullscreenPrompt
